import { useEffect, useState } from "react";
import { cn } from "../../cn";

export interface ProfileImageProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  /** URL of the image, if it is wrong or not provided, the image will be replaced by a default */
  src?: string;
  /** Whether the image is for a team */
  isTeam?: boolean;
}

export default function ProfileImage({
  className,
  isTeam,
  src,
  ...props
}: ProfileImageProps) {
  const [isActive, setIsActive] = useState(!!src);
  const classNames = cn("rounded-full size-28 object-cover", className);

  useEffect(() => {
    setIsActive(!!src);
  }, [src]);

  if (isTeam && !isActive) {
    return <EmptyTeam className={classNames} />;
  }
  if (!isActive) {
    return <EmptyUser className={classNames} />;
  }
  return (
    <img
      className={classNames}
      {...props}
      src={src ?? undefined}
      onError={() => setIsActive(false)}
    />
  );
}

function EmptyTeam(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <svg className={props.className} viewBox="0 0 112 112" fill="none">
      <rect width="112" height="112" rx="56" fill="#C5C5C5" />
      <path
        d="M48.4724 33C42.7661 33 38.2119 37.7091 38.2119 43.4288C38.2119 49.1484 42.7661 53.8575 48.4724 53.8575C54.1787 53.8575 58.7328 49.1484 58.7328 43.4288C58.7328 37.7091 54.1787 33 48.4724 33Z"
        fill="white"
      />
      <path
        d="M63.5276 35.0955C62.3963 35.0955 61.4791 36.0124 61.4791 37.1435C61.4791 38.2745 62.3963 39.1914 63.5276 39.1914C65.7582 39.1914 67.6381 41.0487 67.6381 43.4291C67.6381 45.8095 65.7582 47.6668 63.5276 47.6668C62.3963 47.6668 61.4791 48.5837 61.4791 49.7147C61.4791 50.8458 62.3963 51.7627 63.5276 51.7627C68.1001 51.7627 71.7351 47.9916 71.7351 43.4291C71.7351 38.8666 68.1001 35.0955 63.5276 35.0955Z"
        fill="white"
      />
      <path
        d="M41.2869 56.0473C35.0137 56.0473 30 61.2254 30 67.5236C30 73.8218 35.0137 79 41.2869 79H55.6578C61.931 79 66.9448 73.8218 66.9448 67.5236C66.9448 61.2254 61.9311 56.0473 55.6578 56.0473H41.2869Z"
        fill="white"
      />
      <path
        d="M71.7396 58.1423C70.6082 58.1423 69.6911 59.0592 69.6911 60.1902C69.6911 61.3213 70.6082 62.2382 71.7396 62.2382H72.7661C75.5635 62.2382 77.903 64.5645 77.903 67.5235C77.903 70.4824 75.5635 72.8087 72.7661 72.8087H71.7396C70.6082 72.8087 69.6911 73.7256 69.6911 74.8567C69.6911 75.9877 70.6082 76.9046 71.7396 76.9046H72.7661C77.9054 76.9046 82 72.6645 82 67.5235C82 62.3824 77.9054 58.1423 72.7661 58.1423H71.7396Z"
        fill="white"
      />
    </svg>
  );
}

function EmptyUser(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <svg viewBox="0 0 112 112" className={props.className} fill="none">
      <g clipPath="url(#clip0_183_17928)">
        <rect width="112" height="112" rx="56" fill="#D7D7D7" />
        <rect width="112" height="112" rx="56" fill="#C5C5C5" />
        <path
          d="M56 30C49.2965 30 43.6759 35.2698 43.6759 41.9969C43.6759 48.7239 49.2965 53.9937 56 53.9937C62.7035 53.9937 68.3241 48.7239 68.3241 41.9969C68.3241 35.2698 62.7035 30 56 30Z"
          fill="white"
        />
        <path
          d="M47.5336 55.6724C40.1621 55.6724 34 61.4647 34 68.8362C34 76.2077 40.1621 82 47.5336 82H64.4664C71.8379 82 78 76.2077 78 68.8362C78 61.4647 71.8379 55.6724 64.4664 55.6724H47.5336Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_183_17928">
          <rect width="112" height="112" rx="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
